import strings from "translate/language";
import { errorToast, successToast } from "utils/httpClient";
import announcementService from "../service/announcementService";

export const addUserAnnouncement = (item) => async (dispatch) => {
  try {
    const res = await announcementService.addUserAnnouncement(item);
    if (res.data.status === 200) {
      // dispatch({
      //   type: USER_ANNOUNCEMENT,
      //   payload: res.data,
      // });
      successToast(res.data.message);
      return res.data;
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data.message);
  }
};
